export enum EStatusComissao {
  Pendente = 0,
  Concluida = 1,
  TituloGerado = 2,
  TituloRecebido = 3,
  Todos = 5,
}
